import { FC } from 'react';

import { ICommonIconProps } from '@smartshell/ui-kit';
import cn from 'classnames';

import s from './TableBlock.module.scss';

interface ITableBlockProps {
  Icon: FC<ICommonIconProps>;
  topText: string;
  bottomText: string;
  blue?: boolean;
}
export const TableBlock: FC<ITableBlockProps> = ({
  Icon,
  bottomText,
  topText,
  blue,
}) => (
  <div className={s.container}>
    <div className={cn(s.icon, blue && s.blue)}>
      <Icon size="m" />
    </div>
    <div className={s.info}>
      <span className={s.top}>{topText}</span>
      <span className={s.bottom}>{bottomText}</span>
    </div>
  </div>
);
